export default {
  acceptSimulatedDuration: 'Accept simulated duration',
  simulatedDuration: 'Simulated duration',
  actualValue: 'Actual value',
};
